import type { MentorshipListProgramView } from '@/features/mentorship';
import ProgramCard from '@/features/mentorship/components/list/ProgramCard';

type Props = {
  programs: MentorshipListProgramView[];
};

export default function MentorshipProgramGrid({ programs }: Props) {
  return (
    <section
      id="programs"
      className="container mx-auto px-4 md:py-16 py-0 max-w-400"
      aria-labelledby="programs-heading"
    >
      <div className="flex items-stretch md:grid md:grid-cols-2 lg:grid-cols-4 gap-4 overflow-x-auto md:overflow-visible pb-2 snap-x snap-mandatory">
        {programs.map((program) => (
          <div
            key={program.id}
            className="flex h-full min-w-[280px] md:min-w-0 snap-center shrink-0 md:shrink"
          >
            <ProgramCard program={program} />
          </div>
        ))}
      </div>
    </section>
  );
}
